export const PACKAGES_URL =
	'https://shockpkg.github.io/packages/api/1/packages.json';

export const PACKAGES_FILE = 'packages.json';

export const PACKAGE_FILE = 'package.json';

export const PATH_ENV = 'SHOCKPKG_PATH';

export const PACKAGES_URL_ENV = 'SHOCKPKG_PACKAGES_URL';

export const MAIN_DIR = 'shockpkg';

export const META_DIR = '.shockpkg';

export const TEMP_DIR = 'tmp';
